import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/fastpeps-core-storefront/src/modules/account/components/account-auth-panel/index.tsx");
